import * as React from 'react';
import { useDispatch } from 'react-redux';

import { DEFAULT_MODERATION_LINK } from '../../constants/reviews/moderation';
import { useApplicationContext } from '../../utils/applicationContext';
import { ENewQuestionModalStep } from '../../types/newQuestion';
import { QuestionContainer } from '../NewQuestion';
import { Success } from '../../components/FormCommon/Success';
import { Error } from '../../components/FormCommon/Error';
import { addQuestionActions } from '../../actions/newQuestion/addQuestionActions';

export interface INewReviewModalContentContainerProps {
  step: ENewQuestionModalStep;
  onClose(): void;
}

export const NewQuestionModalContentContainer: React.FC<INewReviewModalContentContainerProps> = props => {
  const dispatch = useDispatch();
  const { config } = useApplicationContext();
  const { step, onClose } = props;
  const moderationUrl = config.get<string>('newbuilding-reviews-frontend.moderationUrl') || DEFAULT_MODERATION_LINK;

  const retry = React.useCallback(() => {
    dispatch(addQuestionActions());
  }, [dispatch]);

  switch (step) {
    case ENewQuestionModalStep.Question: {
      return <QuestionContainer />;
    }
    case ENewQuestionModalStep.Success: {
      return <Success type="вопрос" url={moderationUrl} close={onClose} />;
    }
    case ENewQuestionModalStep.Error: {
      return <Error retry={retry} type="Вопрос" />;
    }
  }
};
